import { FunctionComponent, ReactElement } from "react";
import { ITextCapitalizedProps } from "./types";

export const TextCapitalized: FunctionComponent<ITextCapitalizedProps> = (
  props: ITextCapitalizedProps
): ReactElement<ITextCapitalizedProps> => {
  const { children } = props;

  return (
    <>
      {children.slice(0, 1).toUpperCase() + children.slice(1, children.length)}
    </>
  );
};
